// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"Arrow_arrowButton__1rhGK","upIcon":"Arrow_upIcon__2WVu0","upIconIOS":"Arrow_upIconIOS__n8weU","downIconIOS":"Arrow_downIconIOS__2YRr3"};